import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }

import { FloatButton, Modal } from 'ant-design-vue';
import { HttpStatusCode } from 'axios';
import { createVNode, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { DeleteFilled } from '@ant-design/icons-vue';
import DoujinView from '@/components/disposable/DoujinView.vue';
import DoujinViewSkeleton from '@/components/disposable/DoujinViewSkeleton.vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import { Doujin, RATING_SCORE_MAXIMUM } from '@/model/doujin';
import { getDocumentDetail } from '@/repository/document';
import { deleteDoujin, favoriteDoujin, getDoujin, ratingDoujin } from '@/repository/doujin';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoujinDetailView',
  setup(__props) {

const { params } = useRoute();
const { push } = useRouter();
const store = useStore();

const doujinUUID = params.doujinUUID as string;
const isLoading = ref(true);
const doujin = ref<Doujin>();
const imageURLs = ref<string[]>([]);

onMounted(async () => {
	isLoading.value = true;
	await fetchData();
	await fetchDocument();
	isLoading.value = false;
});

async function fetchData() {
	try {
		const res = await getDoujin(doujinUUID);
		if (!res || res.status !== HttpStatusCode.Ok || !res.data) {
			throw Error('doujin uuid is not found');
		}
		doujin.value = res.data;
		document.title = `${res.data.title} - Doujin | Unikume Kinkando`;
	} catch (error) {
		push(`/doujin`);
	}
}

async function fetchDocument() {
	imageURLs.value = [];
	try {
		const document = await getDocumentDetail(doujin.value?.documentUUID || '');
		if (document?.files) {
			imageURLs.value = document.files.map((file) => file.originalURL);
		}
	} catch (error) {
		push(`/doujin`);
	}
}

async function remove() {
	Modal.confirm({
		title: 'Delete Doujin',
		icon: createVNode(DeleteFilled),
		content: 'Do you want to delete this doujin right?',
		okText: 'Yes',
		cancelText: 'No',
		async onOk() {
			if (doujin.value?.doujinUUID) {
				await deleteDoujin(doujin.value.doujinUUID);
				store.dispatch('alert', { type: 'success', message: 'Delete doujin successfully!' });
				push(`/doujin`);
			}
		}
	});
}

async function favorite() {
	if (!doujin.value) {
		return;
	}
	try {
		doujin.value = { ...doujin.value, isFavorite: !doujin.value.isFavorite };
		await favoriteDoujin(doujin.value.doujinUUID as string, !!doujin.value.isFavorite);
	} catch (error) {
		doujin.value = { ...doujin.value, isFavorite: !doujin.value.isFavorite };
		store.dispatch('alert', { type: 'error', message: 'something went wrong, please try again!' });
	}
}

async function rating(score: number) {
	if (!doujin.value || score < 0 || score > RATING_SCORE_MAXIMUM) {
		return;
	}
	const originalScore = doujin.value.yourRating;
	if (score === originalScore) {
		score = 0;
	}
	try {
		doujin.value = { ...doujin.value, yourRating: score };
		await ratingDoujin(doujin.value.doujinUUID as string, score);
	} catch (error) {
		doujin.value = { ...doujin.value, yourRating: originalScore };
		store.dispatch('alert', { type: 'error', message: 'something went wrong, please try again!' });
	}
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(FloatButton).BackTop),
    (isLoading.value || !doujin.value)
      ? (_openBlock(), _createBlock(DoujinViewSkeleton, { key: 0 }))
      : (_openBlock(), _createBlock(DoujinView, {
          key: 1,
          doujin: doujin.value,
          "onUpdate:doujin": _cache[0] || (_cache[0] = ($event: any) => ((doujin).value = $event)),
          onDelete: remove,
          onFavorite: favorite,
          onRating: rating
        }, null, 8, ["doujin"])),
    (isLoading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(Array(10), (_, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "bg-gray-700 animate-pulse max-w-6xl w-full h-full aspect-square m-auto rounded-none"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_spin, {
                tip: "Loading...",
                size: "large",
                class: "animate-pulse"
              })
            ])
          ]))
        }), 128))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(imageURLs.value, (imageURL, index) => {
          return (_openBlock(), _createBlock(ImageLoading, {
            key: index,
            src: imageURL,
            "img-class": "object-cover w-full h-full rounded-none",
            "loading-class": "max-w-6xl w-full h-full aspect-square m-auto rounded-none"
          }, null, 8, ["src"]))
        }), 128))
  ], 64))
}
}

})